import { isEqual } from 'lodash';
import { Basis } from './studio/channel';
import type { Channel } from './studio/channel';
import type { Device } from './studio/device';

export type KnownChannelData = Omit<Channel, 'label' | 'uuid'>;

const SUPPORTED_DEVICES = ['MockDevice'];

export const allDevices = SUPPORTED_DEVICES;

// The MockDevice specs and MockDevice channels specs are same as the Chadoq2 from Pulser
export const devices: Readonly<Record<string, Device>> = {
  MockDevice: {
    name: 'MockDevice',
    dimensions: 2,
    rydbergLevel: 70,
    maxAtomNum: 100,
    maxRadialDistance: 50,
    minAtomDistance: 4
  }
};

export const deviceChannels: Record<string, KnownChannelData[]> = {
  MockDevice: [
    {
      addressing: 'local',
      basis: Basis.Digital,
      maxAbsDetuning: 125.664,
      maxAmp: 62.832,
      phaseJumpTime: 0,
      minRetargetInterval: 220,
      fixedRetargetT: 0,
      maxTargets: 1,
      clockPeriod: 4,
      minDuration: 16,
      maxDuration: undefined,
      modBandwidth: undefined,
      enableDetuning: false
    },
    {
      addressing: 'local',
      basis: Basis.GroundRydberg,
      maxAbsDetuning: 125.664,
      maxAmp: 62.832,
      phaseJumpTime: 0,
      minRetargetInterval: 220,
      fixedRetargetT: 0,
      clockPeriod: 4,
      maxTargets: 1,
      minDuration: 16,
      maxDuration: undefined,
      modBandwidth: undefined,
      enableDetuning: false
    },
    {
      addressing: 'global',
      basis: Basis.GroundRydberg,
      maxAbsDetuning: 125.664,
      maxAmp: 15.708,
      phaseJumpTime: 0,
      clockPeriod: 4,
      minDuration: 16,
      fixedRetargetT: undefined,
      maxDuration: undefined,
      maxTargets: undefined,
      minRetargetInterval: undefined,
      modBandwidth: undefined,
      enableDetuning: true
    }
  ]
};

/**
 * Check if given device can be modified by the user.
 */
export function isDeviceConfigurable(device: Device) {
  return device.name === 'MockDevice';
}

/**
 * Checks if ch1 and ch2 have same parameters
 *
 * @param ch1
 * @param ch2
 * @returns
 */
export function channelHasSameParameters(
  ch1: KnownChannelData,
  ch2: KnownChannelData
) {
  return isEqual(ch1, ch2);
}
/**
 * Check if given channel can enable/disable detuning
 */
export function channelCanConfigureDetuning(ch: KnownChannelData) {
  return ch.addressing === 'local' && ch.basis === Basis.GroundRydberg;
}
